import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FileManagerService } from '../services/fileManager.services';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MovetoFileManagerComponent } from 'src/app/middleware/common/movetoFileManager/movetoFileManager.component';
import {RenameFileManagerComponent} from 'src/app/middleware/common/renameFileManagerItem/renameFileManager.component';
import { AssociateContactRoleFileManagerListComponent } from '../associate-contact-role-filemanager-list/associate-contact-role-filemanager-list.component';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { COMMA, ENTER, I, L } from '@angular/cdk/keycodes';
import { AddCoreVm, FileModelVM } from 'src/app/viewModels/core/core-vm';
import { MatChipInputEvent } from '@angular/material/chips';
import { SafeResourceUrl } from '@angular/platform-browser';
import { map, startWith } from 'rxjs/operators';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { ModuleName } from '../services/fileManager.enum';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-doc-detail',
  templateUrl: './doc-detail.component.html',
  styleUrls: ['./doc-detail.component.scss']
})
export class DocDetailComponent implements OnInit {

  databaseId:any;
  organizationId:string;
  currentUser: any;

  clickEventsubscription: Subscription;
  folderDetails :any=[]=[];
  selectedRecordDeleteArray: any = [];
  responseHolder: any;
  SharedContactRoleCount:number=0;
  OfficeIDList: any=[];
  myOfficeID: any;
  isFile:boolean=false;
  isSharedWithMeFileManager:string="";
  isShared:any;
  allFormFolderTouchesList: any;
  menuModulesList: any = [];
  folderIdForFileManager=0;
  fileFoldeTypeId:number=0;
  ImagePathURL: string = '';

  timeout = null;
  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;
  stateCtrl = new FormControl();
  scheduledTaskCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  //roleInputCurrentvalue:any;
  stateCtrSendlValue: any;
  stateCtrlValue: string;
  objectList: any = [];
  fileManagerItemID:number=0;

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private toastr: ToastrService, private fileManagerService: FileManagerService, private router: Router,
    private dialog: MatDialog, private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,private statusConst: StatusConstant,
    private fileModelVM: FileModelVM,private addCoreVm: AddCoreVm) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
     var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });

      this.stateCtrl.setValue(this.stateCtrlValue);
      this.filteredStates = this.stateCtrl.valueChanges.pipe(
        startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
      );
   }

    // ngAfterContentChecked() {
    //   this.cdr.detectChanges();    
    // }

    ngOnInit(): void {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.coreFieldSaveCompareForType = [];
    this.coreFieldListForType=[];
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.getAllTagsList();
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.getStateDropdownList(231);  
    
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedFileManager = [];   

    SelectedFileManager = this.menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (SelectedFileManager.length > 0) {
      this.folderIdForFileManager=SelectedFileManager[0].folderID;      
    }

      this.clickEventsubscription = this._dataSharingService.getSelectedFolderDetailsFromLeftMenuFileManager().subscribe((result) => {
       if (result != '' && result != undefined) {
          this.isSharedWithMeFileManager =sessionStorage.getItem('isSharedWithMeFileManager');
          this.isShared =sessionStorage.getItem('isShared');
          this.folderDetails =result;
          this.tabType=0;
          if(this.folderDetails.isFile==true){
            this.fileFoldeTypeId=2;
            this.fileManagerItemID= this.folderDetails.fileManagerItemID;
            this.TypeIdDrp=this.folderDetails.documentTypeID;
            const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
            this.coreFieldSaveCompareForType = [];
            this.coreFieldListForType=[];
            this.dynamicArray = [];
            this.dynamicArrayPhone = [];
            this.dynamicArrayAddress = [];
            this.dynamicArrayWebsite = [];      
            let group = {};
            this.myFormGroup = new FormGroup(group);      
            this.GetFileFields(); 
          }
          if(this.folderDetails!=null || this.folderDetails!=undefined){
            this.getSharedContactRoleList(this.folderDetails);           
          }         
          }else{
            this.folderDetails=[];
          }
        });
    
      this.clickEventsubscription = this._dataSharingService.getRenamedItemForFileManager().subscribe((result) => {
       if (result != '' && result != undefined) {  
            if(this.folderDetails.length>0)       
            this.folderDetails= [];                   
            }else{
            }
          });
    
      this.clickEventsubscription = this._dataSharingService.getFolderDetailsEmpty().subscribe((result) => {
        if (result =='') {              
            this.folderDetails=[];
         }
        });
   
      this.clickEventsubscription = this._dataSharingService.getRefreshDetailsSharedRoleListForFileManager().subscribe((result) => {
          if(result!='' && result!=undefined) {   
            this.getSharedContactRoleList(this.folderDetails);   
            //this.GetAllFormTouches(this.folderDetails);
          }
        });
     }
     
     ngOnChanges(changes: SimpleChanges) {     
  
     }

     states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  tabType:number=0;

     onTabClick(event) {
      this.tabType=event.index;
      if(event.tab.textLabel=="Details" || event.index==0){
        //this.allFormFolderTouchesList=[];
       // this.GetAllFormTouches(this.folderDetails);
      } 

      if(event.tab.textLabel=="Activity" || event.index==1){
        this.allFormFolderTouchesList=[];
        this.GetAllFormTouches(this.folderDetails);
      }  
       
    }



   async GetAllFormTouches(folderDetail) {
      var typeId=0;
      // 1 for Folder , 2 for File
     if(folderDetail.isFile==false){ //Folder
      typeId=1;
     }
     if(folderDetail.isFile==true){ //File
      typeId=2;
     }
     this.fileFoldeTypeId=typeId;
    var ReqModel={
      folderID:1,//this.folderIdForFileManager,    
      databaseID:Number(this.databaseId),
      organizationID:Number(this.organizationId),   
      //transactionID:0,
      //placeholderID:0,
      documentID:folderDetail.fileManagerItemID,
      //itemType:typeId,
      //touchesType:0,    
      officeID:this.myOfficeID,
      userID:this.currentUser.UID    
    }  
    const result = await this.fileManagerService.GetAllFileManagerTouches(ReqModel).toPromise();
     if (result.status === this.statusConst.statusSuccess) {    
       this.allFormFolderTouchesList=result.data==null?[]:result.data;
       if(this.allFormFolderTouchesList !=null){
         this.allFormFolderTouchesList.map((res) => {
           if (res.createdByLastName != null) {
             res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByFirstName);
           }
           if (res.createdByLastName != null) {
             res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
           }             
           return res;
         });  
       }          
     }
     else {     
     } 
   }

   addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:"File Manager",
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: this.folderDetails.fileManagerItemID,
        cType:5 // File Manager       
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
        this.GetAllFormTouches(this.folderDetails);
      }
    });   
  }

   async getSharedContactRoleList(folderDetail) {  
     var typeId=0;
      // 1 for Folder , 2 for File
     if(folderDetail.isFile==false){ //Folder
      typeId=1;
     }
     if(folderDetail.isFile==true){ //File
      typeId=2;
     }
     this.fileFoldeTypeId=typeId;
    var ReqModel={
      nameFieldID:0,
      emailFieldID:0,
      databaseID:Number(this.databaseId),
      organizationID:Number(this.organizationId),   
      itemID:folderDetail.fileManagerItemID,
      itemType:typeId,
      pageIndex:0,
      pageSize:0,
      officeID:this.myOfficeID,
      userID:this.currentUser.UID    
    }    
    const result = await this.fileManagerService.GetAllFileFolderSharedTo(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {    
      this.responseHolder = result.data.fileSharedToList;
      if(this.responseHolder !=null){
        this.SharedContactRoleCount =this.responseHolder.length;            
      }          
    }
    else {      
    } 
  }

  DeleteFolders(form) {
      var message = `Are you sure you want to delete folder?`;
      const title = `Confirm Delete`;
      const confirm = `Delete`;
      const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });  
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        if (dialogResult) {
          let request = {
            id: form.fileManagerItemID, // FolderID  |  FormID
            itemType: 1, //{ 1- Folder, 2- Form}
          };
  
          this.selectedRecordDeleteArray.push(request);
  
          var ReqModel = {
            items: this.selectedRecordDeleteArray,
            actionType: -1, //(-1 For Remove),(1 For Favorite)
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          };
          this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.data == 1) {
                this.toastr.success('Folder deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.folderDetails=[];
                this._dataSharingService.sendRefreshListForFileManager(true);
                this.selectedRecordDeleteArray = [];               
              }
            }
          });
        }
      });
  }  
    
  MoveTo(folder) {
    const dialogRef = this.dialog.open(MovetoFileManagerComponent, {
      data: {       
        fileManagerItemID: folder.fileManagerItemID
      }
    });
    dialogRef.afterClosed().subscribe(result => {
        this._dataSharingService.getSelectedParentFolderIDForMoveFileManagerItem().subscribe(response=>{
          if(result!=undefined){               
            this.folderDetails=[];
            this._dataSharingService.sendRefreshListForFileManager(true);
            this.selectedRecordDeleteArray = [];
          }
      });
    });
  }

  renameFileManagerItem(fileManagerItemDetails){
    const dialogRef = this.dialog.open(RenameFileManagerComponent, {
      data: {       
        fileManagerItemID: fileManagerItemDetails
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=undefined){
        fileManagerItemDetails.name= result; 
        this._dataSharingService.sendRefreshListForFileManager(true);     
        this.selectedRecordDeleteArray = [];
      }     
    });
  }
  
  DeleteFile(form) {
      var message = `Are you sure you want to delete file?`;
      const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });  
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        if (dialogResult) {
          let request = {
            id: form.fileManagerItemID, // FolderID  |  FormID
            itemType: 2, //{ 1- Folder, 2- Form}
          };
  
          this.selectedRecordDeleteArray.push(request);
  
          var ReqModel = {
            items: this.selectedRecordDeleteArray,
            actionType: -1, //(-1 For Remove),(1 For Favorite)
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          };
          this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.data == 1) {
                this.toastr.success('File deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.folderDetails=[];          
                this._dataSharingService.sendRefreshListForFileManager(true);
                this.selectedRecordDeleteArray = [];               
              }
            }
          });
        }
      });
  }
  

  showSharedContactRoleList() {
    if (this.folderDetails.isFile == false) {     
      var FolderID = this.folderDetails.fileManagerItemID;     
    }
    if (this.folderDetails.isFile == true) {
      var FileID = this.folderDetails.fileManagerItemID;     
    }
    const dialogRef = this.dialog.open(AssociateContactRoleFileManagerListComponent, { 
      id: 'addContactOrRoleDialog',   
      panelClass: 'custom-modalbox', 
      data: {
        moduleName: 'File Manager',
        FileFolderID: FolderID,
        FileID: FileID,
        isFile: this.folderDetails.isFile,       
      }
    });
    dialogRef.afterClosed().subscribe(result => { 
     
    });  
  }





  coreFieldSaveCompareForType: any[];
  coreFieldListForType: any[];
  myFormGroup: FormGroup;
  transactionUserName: any;
  transactionUserRole: any;
  addressFormGroup: any=[];
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  addressValue:any;
  cityValue: any;
  stateValue: any;
  zipValue: any;
  grpToggle: boolean = true;
  checkboxStatus: boolean = false;
  coreFieldList: any;
  coreFieldSaveCompare: any;
  coreFieldListSubmit: any;
  ImageUploadURL: any = '';
  imagelist: any;
  dropdownlist: any=[]=[];
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;
 
  chkStatusArry: any;
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  @Output() closeAdd = new EventEmitter<boolean>();
  tempValue: any;
  TypeList: any = [];
  step = 0;


  AllTypeList: any = [];
  selectedTypeList: any;

  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  getSubFolderFieldsListResponseHolder: any;
  getTagListResponseHolder: any;
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0
  };
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize:0,
    OfficeIDList:[],
    officeID:0
  };
  CityModel = {
    Name: '',
    databaseID: 0,
    userID:''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID:''
  };

  
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];


  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  
  cityOption: string[]=[];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[] = [];
  allTags: string[] = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('Input') InputFile: ElementRef;
  //@ViewChild('repeatTaskFieldId') repeatTaskFieldId: ElementRef;
  @ViewChild('repeatTaskFieldId') selectElement: MatSelect;
  
  arryaControlNameIdpare: any=[];
  tagvalues: string;
  zipOption: any[];
  stateList: any[];
  selectedFieldValue: any=10433 ;
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  coreUserList: any;
  transactionID: number;
  isTypeChanged: boolean=false;
  TypeIdDrp:number=0;
  arrayControlNameSubfolderID: any=[];
  dynamicArrayEdit: any;
  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;
  emptyArrya: any=[];
  taskListName:string="";

  public showSpinners = true;
  currentFormLinkFormName: any='';
  @Input() mainModulename: string;
  @Input() SingleTaskArchived:boolean;

  repeatTaskEmail:string="";
  EmailTemplate:string="";
  showRepeatTaskEmail:boolean=false;
  showRepeatTaskForCCC:boolean=false;
  addByEmail:string="";
  addByName:string="";
     
  
  
    getdropdownlist(fieldName) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      return _newdropdownlist[0]!=undefined ? _newdropdownlist[0].value :"";
    }
  
    getMuldropdownlist(fieldName) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      return _newMuldropdownlist[0]!=undefined ? _newMuldropdownlist[0].value :"";
    }
  
    
    getCheckBoxlist(fieldName) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      return _newcheckBoxlist[0]!=undefined ? _newcheckBoxlist[0].value :"";
    }
  
    OnChange($event: any, chk: any, fieldId: any) {   
      let ckhchecked = [];
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      if ($event.checked) {
        this.chkStatusArry.push({
          ckh: chk,
          fieldId: fieldId,
        });
      } else {
        if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
          this.chkStatusArry = this.chkStatusArry.filter(
            (item) =>
              item.ckh != chk
          );
        }
      }
    }
  
    isChecked(fieldName, chk) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      if (_newcheckBoxlist[0].selectedCHK != '') {
        return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
      } else {
        return false;
      }
    }

    getddlSelectedVal(fieldName) {
      if (this.dropdownlist) {
        var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
        if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '' && _newdropdownlist[0].selectedVal != undefined) {
          return _newdropdownlist[0].selectedVal;
        } else {
          return '';
        }
      }
    }

    getMultiddlSelectedVal(fieldName) {
      if (this.multipleDropdownList) {
        var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
        if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '' && _newMuldropdownlist[0].selectedVal!= undefined) {
          if(fieldName!="Tags"){         
            return _newMuldropdownlist[0].selectedVal.split(',');
          }else{
            return _newMuldropdownlist[0].selectedVal;
          }
        } else {
          return '';
        }
      }
    }

    add(event: MatChipInputEvent): void {
      const input = event.input;
      const value = event.value.toLowerCase();
      this.allTags;
      var check=[];
      check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
      if(check.length>0){
       this.fruitCtrl.setValue(null);
       return;
      }   
      // Add our tag
      if ((value || '').trim()) {
        var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
        const index = arrToUp.indexOf(value.trim());
        if (index >= 0) {
        }
        else {
          this.tags.push(event.value.trim());
        }
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
  
      this.fruitCtrl.setValue(null);
    }
  
    remove(fruit: string): void {
      const index = this.tags.indexOf(fruit);
  
      if (index >= 0) {
        this.tags.splice(index, 1);
      }
    }
  
    selected(event: MatAutocompleteSelectedEvent): void {
      this.tags =  this.tags.map(function (el) {
        return el.trim();
      });
      const index = this.tags.indexOf(event.option.viewValue);
  
      if (index >= 0) {
        this.fruitInput.nativeElement.value = '';
        //this.fruits.splice(index, 1);
      }
      else {
        this.tags.push(event.option.viewValue);
        this.fruitInput.nativeElement.value = '';
        this.fruitCtrl.setValue(null);
      }
    }
    
    getCoreUserDetailsOnTypeChange(event:any,fieldName:any){  
      this.transactionID;
      this.isTypeChanged=true;
      this.TypeIdDrp = parseInt(event.value);   
      this.arryaControlNameIdpare=[]
      this.arrayControlNameSubfolderID=[];
      this.GetFileFields();  
   }

   onDocumentTypeChange(event:any){     
    this.isTypeChanged=true;
    this.TypeIdDrp = parseInt(event.value);   
    this.arryaControlNameIdpare=[]
    this.arrayControlNameSubfolderID=[];
    this.GetFileFields();  
 }

   transactionIDForTask:number=0;
   typeIdForTask:number=1;
   NameForTask:string="";
   EmailForTask:string="";
   ImageForTask:string="";
   documentTypeList:any=[]=[];

   GetFileFields() {      
    var reqModel={
      fileID: this.fileManagerItemID,
      documentTypeID:this.TypeIdDrp,
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),          
      officeID:this.myOfficeID,
    }   
    this.loaderService.show();
    this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          this.documentTypeList= response.data.docTypes;
          this.coreUserList = response.data.docTypeFields;       
          this.coreFieldSaveCompare = response.data.docTypeFields;
          this.coreFieldList = response.data.docTypeFields;

          if(this.coreUserList.length>0){
            this.coreUserList.forEach(e => {
              e.fieldValue = e.value
            });
          }
          //this.TypeListForDropDown =response.data.docTypes;
          //this.TypeListForDropDown.splice(0,0,{folderName: "Select",isChecked: false,subFolderID: 0});
         
          // var TypeData =  this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type'); 
                     
          // if(TypeData!=undefined && TypeData!='' && TypeData!=null && isFromDDlType==false)
          // {
          //   this.TypeIdDrp=Number(TypeData[0].fieldValue);
          // }
          // var taglist;
          // taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          // if (taglist.length > 0 && taglist !=undefined) {
          //   this.tags = [];
          //   if(taglist[0].fieldValue != ""){
          //     var str = taglist[0].fieldValue;
          //     var selectedValues = str.replace(/^,|,$/g, '');
          //     this.tags = selectedValues.split(',');             
          //   }
          //   else {
          //     this.tags=[];
          //   }           
          // }
          // else {
          //   this.tags=[];
          // }   
  
          // var NewList;
          // NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
         
          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;
         
          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          // let multiNameArray = [];
          // let ArrayWithGroupedElement = [];
          // this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2); 
          // this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);
                   
          // this.coreUserList.forEach((formControl) => {
          //   let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
          //   if (count == 0) {
          //       multiNameArray.push(formControl);
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });
  
          //       if(formControl.fieldName.includes('Address'))
          //       {
          //        formControl.address.forEach((ac,i) =>  {
          //         if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType),
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }        
          //   }
          //  else if (count > 0) {
          //     multiNameArray.push(formControl);
          //     formControl.fieldName = formControl.fieldName + count;
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });
          //       if(formControl.fieldName.includes('Address')){
          //        formControl.address.forEach((ac,i) => {
          //          if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType)+count,
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }           
          //   }
          // });
  
  
          // this.coreUserList.forEach((formControl) => {
          //   let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0).length;
          //   let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0);
          //   if (count == 0 && elements.length > 0) {
          //     if (elements[0].fieldName.includes('Address')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
          //       this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Email')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
          //       this.dynamicArrayTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Phone')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
          //       this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Website')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
          //       this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
          //     }
              
          //     ArrayWithGroupedElement.push(elements[0]);             
          //   }
          //   if (count == 0 && elements.length == 0)
          //     ArrayWithGroupedElement.push(formControl);
          // });
          
          // this.coreUserList = ArrayWithGroupedElement;
        
           const Fields = {};
           this.coreUserList.forEach((formControl) => {
            // if (formControl.fieldName == 'Name') {
            //   //this.transactionUserName = this.taskDetailList.title;            
            // }
            // if (formControl.fieldName == 'Type') {           
            //   let type=this.TypeListForDropDown.find(x=>x.subFolderID==formControl.fieldValue);
            //   this.transactionUserRole = (type!=null ||type!=undefined)?type.folderName:""
            // }
            Fields[formControl.fieldName] = new FormControl('');
            // if (formControl.fieldName.length > 0) {
            //   Fields[formControl.fieldName + 'option'] = new FormControl('');

            //   let plcHolder = formControl.fieldName.find((x) => x.fieldID == formControl.fieldID);
            //   formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldName;

            //  // let plcHolder = formControl.fieldNames.find((x) => x.fieldNameID == formControl.fieldNameID);
            //  // formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            // }           
          });
          // this.ImagePathURL = (response.data.imageUrl==null || response.data.imageUrl==undefined || response.data.imageUrl=='')?'':response.data.imageUrl;
          
          // Fields['City'] = new FormControl();
          // Fields['State'] = new FormControl();
          // Fields['ZipCode'] = new FormControl();
          // Fields['Country'] = new FormControl();
          
            // address computaion array for computation
        //  this.addressFormGroup.push('Address');
        //  this.addressFormGroup.push('City');
        //  this.addressFormGroup.push('State');
        //  this.addressFormGroup.push('ZipCode');
        //  this.addressFormGroup.push('Country');
        
        //   Fields['fruitCtrl'] = this.fruitCtrl; 
           this.myFormGroup = new FormGroup(Fields);          
  
           this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
           this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
           this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
             
           var data = [];

           data=this.coreUserList.filter((s) => s.fieldID ==0);
 
           if (data.length > 0) {
             for (var i = 0, len = data.length; i < len; ++i) {
               var DrpData = [];
               DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
               if(DrpData.length>0){
                 for (var v = 0, char = DrpData.length; v < char; ++v) {
                   this.dropdownlist.push(DrpData[v]);
                 }
               }
              
               var MultiData=[];
               MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
               if(MultiData.length>0){
                 for (var v = 0, char = MultiData.length; v < char; ++v) {
                   this.multipleDropdownList.push(MultiData[v]);
                 }
               }
               
               var CheckboxData=[];
               CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
               if(CheckboxData.length>0){
                 for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                   this.checkBoxList.push(CheckboxData[v]);
                 }
               }             
             }
           }               
 
             if (this.dropdownlist.length > 0) {
               var fieldListdrp = [];
               var value;
               for (let i = 0; i < this.dropdownlist.length; i++) {
                 var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                 value = drpValue.split(',');
                 var FieldsDrp = {
                   FieldValue: this.dropdownlist[i].fieldName,
                   value: value,
                 };
                 fieldListdrp.push(FieldsDrp);
               }
               this.dropdownlist = fieldListdrp;
             }
 
             if (this.multipleDropdownList.length > 0) {
               var fieldmulListdrp = [];
               var value;
               for (let i = 0; i < this.multipleDropdownList.length; i++) {
                 var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                 value = muldrpValue.split(',');
                 var FieldsMulDrp = {
                   FieldValue: this.multipleDropdownList[i].fieldName,
                   value: value,
                 };
                 fieldmulListdrp.push(FieldsMulDrp);
               }
               this.multipleDropdownList = fieldmulListdrp;
             }
 
             if (this.checkBoxList.length > 0) {
               var fieldcheckbox = [];
               var value;
               for (let i = 0; i < this.checkBoxList.length; i++) {
                 var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                 value = checkboxValue.split(',');
                 var FieldsCheckbox = {
                   FieldValue: this.checkBoxList[i].fieldName,
                   value: value,
                 };
                 fieldcheckbox.push(FieldsCheckbox);
               }
               this.checkBoxList = fieldcheckbox;
             }   

           // Modified array containing group ends 
           this.fillCheckBoxList();
           this.prepareCheckboxListForUI();

           this.fillDropDown();
           this.prepareDropDownForUI();

           this.fillMultiDropDown();
           this.prepareMultiDropDownForUI();      

          // //#region geting core filds
          // var reqModel={
          //   fileID: this.fileManagerItemID,
          //   documentTypeID:this.TypeIdDrp,
          //   userID : this.currentUser.UID,
          //   organizationID: Number(this.organizationId),
          //   databaseID: Number(this.databaseId),          
          //   officeID:this.myOfficeID,
          // }           
          // this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
          //  var tempArryacoreFieldList=response.data.docTypeFields.filter((m) => m.fieldID == 0);
          //   response.data.docTypeFields = response.data.docTypeFields.filter((m) => m.fieldID > 0);
          //   this.coreFieldList = response.data.docTypeFields;
          //    // Modified array containing group starts
          //     // tempArryacoreFieldList.forEach(element => {
          //     //   if(element.data.length>1) {
          //     //     var indexArray=[];                  
          //     //     element.data.forEach(elementin => {
          //     //       if(elementin.fieldID>0){
          //     //         let grpele=this.coreUserList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
          //     //         elementin.id=grpele!=undefined?grpele.id:0;
          //     //         elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
          //     //         if(elementin.fieldNames.length>0){
          //     //         elementin.fieldNameID=grpele.fieldNameID;
          //     //         elementin.placeholderVal=grpele.placeholderVal;                       
          //     //         }
          //     //         this.coreFieldList.push(elementin);
          //     //         if (!this.myFormGroup.contains(elementin.fieldName)){
          //     //           this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
          //     //         }
          //     //         var index = this.coreUserList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         indexArray.push(index);
          //     //       }
          //     //     });                 
                 
          //     //     this.coreUserList = this.coreUserList.filter(function(value, index) { 
          //     //       return indexArray.indexOf(index) == -1; 
          //     //     }) ;
          //     //     this.coreUserList.splice(indexArray[0],0,element);                  
          //     //   }
          //     // });            
            
          //     // ArrayWithGroupedElement.forEach(element => {
          //     //   if(element.fieldName=="Address"){
          //     //     if(element.address.length>0){
          //     //       if(element.address.find(m=>m.childFieldType==3)!=undefined)
          //     //         this.cityValue=element.address.find(m=>m.childFieldType==3).fieldValue;
          //     //         else
          //     //         this.cityValue="";
          //     //       if(element.address.find(m=>m.childFieldType==2)!=undefined)
          //     //         this.stateValue=element.address.find(m=>m.childFieldType==2).fieldValue;
          //     //         else
          //     //         this.stateValue="";
          //     //       if(element.address.find(m=>m.childFieldType==4)!=undefined)
          //     //         this.zipValue=element.address.find(m=>m.childFieldType==4).fieldValue;
          //     //         else
          //     //         this.zipValue="";
          //     //     }
          //     //   }
          //     // });
              
          //     this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          //     this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
          //     this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
                
          //     var data = [];
  
          //     data=this.coreUserList.filter((s) => s.fieldID ==0);
    
          //     if (data.length > 0) {
          //       for (var i = 0, len = data.length; i < len; ++i) {
          //         var DrpData = [];
          //         DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
          //         if(DrpData.length>0){
          //           for (var v = 0, char = DrpData.length; v < char; ++v) {
          //             this.dropdownlist.push(DrpData[v]);
          //           }
          //         }
                 
          //         var MultiData=[];
          //         MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
          //         if(MultiData.length>0){
          //           for (var v = 0, char = MultiData.length; v < char; ++v) {
          //             this.multipleDropdownList.push(MultiData[v]);
          //           }
          //         }
                  
          //         var CheckboxData=[];
          //         CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
          //         if(CheckboxData.length>0){
          //           for (var v = 0, char = CheckboxData.length; v < char; ++v) {
          //             this.checkBoxList.push(CheckboxData[v]);
          //           }
          //         }             
          //       }
          //     }               
    
          //       if (this.dropdownlist.length > 0) {
          //         var fieldListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.dropdownlist.length; i++) {
          //           var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          //           value = drpValue.split(',');
          //           var FieldsDrp = {
          //             FieldValue: this.dropdownlist[i].fieldName,
          //             value: value,
          //           };
          //           fieldListdrp.push(FieldsDrp);
          //         }
          //         this.dropdownlist = fieldListdrp;
          //       }
    
          //       if (this.multipleDropdownList.length > 0) {
          //         var fieldmulListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.multipleDropdownList.length; i++) {
          //           var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
          //           value = muldrpValue.split(',');
          //           var FieldsMulDrp = {
          //             FieldValue: this.multipleDropdownList[i].fieldName,
          //             value: value,
          //           };
          //           fieldmulListdrp.push(FieldsMulDrp);
          //         }
          //         this.multipleDropdownList = fieldmulListdrp;
          //       }
    
          //       if (this.checkBoxList.length > 0) {
          //         var fieldcheckbox = [];
          //         var value;
          //         for (let i = 0; i < this.checkBoxList.length; i++) {
          //           var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
          //           value = checkboxValue.split(',');
          //           var FieldsCheckbox = {
          //             FieldValue: this.checkBoxList[i].fieldName,
          //             value: value,
          //           };
          //           fieldcheckbox.push(FieldsCheckbox);
          //         }
          //         this.checkBoxList = fieldcheckbox;
          //       }   
  
          //     // Modified array containing group ends 
          //     this.fillCheckBoxList();
          //     this.prepareCheckboxListForUI();
  
          //     this.fillDropDown();
          //     this.prepareDropDownForUI();
  
          //     this.fillMultiDropDown();
          //     this.prepareMultiDropDownForUI();              
          //   });
         
          // this.dynamicArray=[];
          // this.dynamicArrayAddress=[];
          // this.dynamicArrayPhone=[];
          // this.dynamicArrayWebsite=[];
          // if(this.dynamicArrayTemp!=undefined){
          //   this.dynamicArrayTemp.forEach((e,i) => {
          //     this.appendEle(e, 1,i+1);
          //   });
          // }
          // if(this.dynamicArrayAddressTemp!=undefined){
          //   this.dynamicArrayAddressTemp.forEach((e,i) => {
          //     this.appendEle(e, 2,i+1);
          //   });
          // }
          
          // if(this.dynamicArrayPhoneTemp!=undefined){
          //   this.dynamicArrayPhoneTemp.forEach((e,i) => {
          //     this.appendEle(e, 3,i+1);
          //   });
          // }
          
          // if (this.dynamicArrayWebsiteTemp != undefined)
          //   this.dynamicArrayWebsiteTemp.forEach((e,i) => {
          //     this.appendEle(e, 4,i+1);
          //   });
            this.loaderService.hide();
          // if(this.isTypeChanged){
            // this.myFormGroup.get('Type').markAsDirty();
          //   this.isTypeChanged=false;
          // }
        } else {
          this.coreUserList = [];
          this.loaderService.hide();
        }
      }else{
        this.coreUserList = [];
        this.loaderService.hide();
      }
    });
  }

  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');      
    }
  }

  appendEle(field: any, type: any,index:any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);
  
    let addressRefactor:any=[];
    if(field.address!=undefined && field.address.length>0)
    {
    addressRefactor.push(field.address.find(x=>x.childFieldType==0));
    addressRefactor.push(field.address.find(x=>x.childFieldType==3));
    addressRefactor.push(field.address.find(x=>x.childFieldType==2));
    addressRefactor.push(field.address.find(x=>x.childFieldType==4));
    }
  
  // addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address:addressRefactor,
      isPrimary:field.isPrimary
    };
   
    
    //1 Email ,2 Address,3 Phone,4 website
    if(type==2){
      this.myFormGroup.addControl('City' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index,this.formBuilder.control(''));   
  
      // address array for computation
      this.addressFormGroup.push('Address'+ index);
      this.addressFormGroup.push('City'+ index);
      this.addressFormGroup.push('State'+ index);
      this.addressFormGroup.push('ZipCode'+ index);
      this.addressFormGroup.push('Country'+ index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);    
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {       
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(','); 
        var selectedVal;
        let chk=this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);
      
        if(chk.length>0){
          selectedVal=chk[0].fieldValue;
        }
         else{
         selectedVal=this.checkBoxList[i].fieldValue
        }  
  
        if(selectedVal==undefined || selectedVal==null){
          selectedVal="";
        }
        // if(chk.length==0){
        //   selectedVal="";
        // } 
        
        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };
  
        fieldcheckbox.push(FieldsCheckbox);
  
        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }
  
  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }
  
  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp=this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if(drp.length>0){
          selectedVal=drp[0].fieldValue;
        }
        else{
         selectedVal=this.multipleDropdownList[i].fieldValue
       }
  
       if(selectedVal==undefined || selectedVal==null){
        selectedVal="";
       }
      //  if(drp.length==0){
      //   selectedVal="";
      //  } 
  
        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal:selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }
  
  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }
  
  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {
  
        if(this.dropdownlist[i].defaultValue.length > 0)  {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
         let drp=this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
         if(drp.length>0){
           selectedVal=drp[0].fieldValue;
         }
         else{
          selectedVal=this.dropdownlist[i].fieldValue
        } 
  
        if(selectedVal==undefined || selectedVal==null){
          selectedVal="";
        }
        // if(drp.length==0){
        //   selectedVal="";
        //  }
         
         var FieldsDrp = {
          FieldValue: this.dropdownlist[i].fieldName,
          value: value,
          selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
        };
        fieldListdrp.push(FieldsDrp);
       }
      }
      this.dropdownlist = fieldListdrp;      
    }
  }

  numberOnlyForSch(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addressValueField: any=Object;
  cityValueField: any=Object; 
  stateValueField: any=Object; 
  zipValueField: any=Object; 

  addMoreEditField(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl( fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl( fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
          var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
          var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length]='';
      this.cityValueField['City' + length]='';
      this.stateValueField['State' + length]='';
      this.zipValueField['ZipCode' + length]=''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length,this.formBuilder.control(''));   

      // address array for computation
      this.addressFormGroup.push('Address'+ length);
      this.addressFormGroup.push('City'+ length);
      this.addressFormGroup.push('State'+ length);
      this.addressFormGroup.push('ZipCode'+ length);
      this.addressFormGroup.push('Country'+ length);
     
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address:this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
         var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  showMap = false;
  urlSafe: SafeResourceUrl;

  showLocationOnMap(add : string){
    const zipCode = this.myFormGroup.get('ZipCode').value;
    const city = this.myFormGroup.get('City').value
    const state = this.myFormGroup.get('State').value
    // let url = `https://maps.google.com/maps?q=${add}${city}${state}${zipCode}=&output=embed`;
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    // this.showMap = !this.showMap;
   }

   clearDate(field) {
    return field.fieldValue="";    
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }

  searchZip(zip :any){
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;
    this.fileManagerService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {     
          this.zipOption=[];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name :any){ 
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;
    this.fileManagerService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  onSelectFile(fileInput: any) {
    //this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }


  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.getTagListModel.officeID=this.myOfficeID;
	  this.getTagListModel.OfficeIDList=this.OfficeIDList;
    this.fileManagerService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;         
        }
        else {
  
        }
      }
    });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.fileManagerService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConst.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){              
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              }             
            }
          }
        });
    }
  }


  getAddressTypeFieldName(childFieldType){
    if(childFieldType==3)
    return 'City';
    if(childFieldType==2)
    return 'State';
    if(childFieldType==4)
    return 'ZipCode';
    if(childFieldType==1)
    return 'Country';
   }
   
   spinner:boolean=false;

   onSubmit(formValues, form) {
    if(this.TypeIdDrp==0){
      this.toastr.warning('Please select document type.', '', {
        timeOut: 3000,
      });
      return
    }
    this.spinner=true;
    this.myFormGroup.markAsPristine();

    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
           
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              // if (s.fieldName.length > 0) {
              //   s.fieldNameID =
              //   (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
              //       ? s.fieldNames[0].fieldNameID
              //       : Number(formValues[s.fieldName + 'option']);
              // }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if(key != 'Addressoption' && key != 'Emailoption' && key != 'Phoneoption' && !key.includes('option')){
            if (control != undefined) {
              if (control.fieldName.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  value: formValues[key],
                   fieldNameID:
                   (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                       ? control.fieldNames[0].fieldNameID
                     : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          // if (tempList[0].fieldTypeName == 'Image') {
          //   if (formValues[key].length == 0) {
          //     selectedValues = '';
          //   } else {
          //     selectedValues = this.ImageUploadURL; 
          //   }
          // }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      // this.imagelist.forEach((element) => {
      //   var FieldsImg = {
      //     FieldID: element.fieldID,
      //     FieldName: element.fieldName,
      //     FieldValue: this.ImageUploadURL,
      //     FieldNameID: null,
      //   };
      //   fieldList.push(FieldsImg);
      // });
     
     
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
    //   let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
    //   let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["City"],
    //     "childFieldType": 3
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["State"],
    //     "childFieldType": 2
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["ZipCode"],
    //     "childFieldType": 4
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["Country"],
    //     "childFieldType": 1
    //   })
    // fieldList = fieldList.filter(function(value, index) { 
    //     return index != indexDefault; 
    // }) ;
    // fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    

      //
      // this.dynamicArrayAddress.forEach((element,i) => {
      //   i=i+1;
      //   let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
      //   let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["City"+i],
      //     "childFieldType": 3
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["State"+i],
      //     "childFieldType": 2
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["ZipCode"+i],
      //     "childFieldType": 4
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["Country"+i],
      //     "childFieldType": 1
      //   })
      // fieldList = fieldList.filter(function(value, index) { 
      //     return index != indexDynamic; 
      // }) ;
      // fieldList.splice(indexDynamic,0,AddressDynamic);

      // });
      //********** */
     // fieldList=[];

      // let myObject;
      // myObject=params;
      // for (let key in myObject) {
      //   if(myObject.hasOwnProperty(key)) {
      //     if(key != "token" && key != "type"){
      //       var obj={
      //         parameterName:key,
      //         value:myObject[key],
      //       }
      //       this.urlParameter.push(obj);
      //     }
      //   }
      // }
       //fieldList

      //  if(this.coreFieldSaveCompare.length>0){
      //   this.coreFieldSaveCompare.forEach((element) => {
      //     var obj = {
      //       fieldID: element.fieldID,
      //       value: element.fieldValue,         
      //   };
      //    fieldList.push(obj);
      //   });       
      // }

      var NewfieldList=[];

       if(fieldList.length>0){
        fieldList.forEach((element) => {
          var obj = {
            fieldID: element.FieldID,
            value: element.FieldValue,         
        };
          NewfieldList.push(obj);
        });       
      }

      

        var reqModel ={       
          documentID : Number(this.fileManagerItemID),
          documentTypeID : Number(this.TypeIdDrp),
          fields : NewfieldList,
          userID : this.currentUser.UID,
          organizationID :  Number(this.organizationId),  
          databaseID : Number(this.databaseId),        
          officeID: this.myOfficeID,        
       }
     
      this.loaderService.show();
      //return;
      this.fileManagerService.updateDocumentTypeFields(reqModel).subscribe((response) => {
      if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;             
              this.tags = [];
              //this.myFormGroup.reset();           
              this.GetFileFields();             
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
            }else{
              this.spinner=false;
              this.loaderService.hide();
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        });
    }
  }

    // handleInputChange(files) {
    //   var file = files;
    //   var pattern = /image-*/;
    //   var reader = new FileReader();
    //   if (!file.type.match(pattern)) {
    //     alert('invalid format');
    //     return;
    //   }
    //   this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    //   reader.readAsDataURL(file);
    // }
  
    // _handleReaderLoaded(e) {
    //   let reader = e.target;
    //   var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    //   this.imageSrc = base64result;
    //   this.fileModelVM.UserID = this.currentUser.UID;
    //   this.fileModelVM.DatabaseID = Number(this.databaseId);
    //   this.fileModelVM.OrganizationID = Number(this.organizationId);
    //   this.fileModelVM.Base64String = this.imageSrc;
    //   this.fileModelVM.FileName = this.FileName;
    //   this.fileModelVM.FileExtention = this.FileExtention;
    //   this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
    //       if (response != undefined) {
    //         this.responseHolder = response;
    //         if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //           this.ImageUploadURL = response.data;
    //         }
    //       }
    //     });
    // }
  
}
